import Axios from 'axios';
const Gettext = require('node-gettext');
const gt = new Gettext({ debug: false });
var _ = (text) => {
    return gt.gettext(text);
}

const loadTranslations = (callback) => {
    Axios.get('/api/i18n/json')
        .then((response) => {
            gt.addTranslations(response.data.locale_name, 'messages', response.data.translations);
            gt.setLocale(response.data.locale_name);
            callback(true);
        })
        .catch(err => {
            console.log(err);
            callback(false);
        })
}

export { _ as default, loadTranslations };